
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(612|721|89)$/.test(chunkId);
},
rootOutputDir: "../",

    };
}
